import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_COURSE_COMPONENTS, 
    ADD_NEW_COURSE_COMPONENT, 
    UPDATE_COURSE_COMPONENT, 
    DELETE_COURSE_COMPONENT 
} from "./actionTypes";
import {
    getCourseComponentsSuccess,
    getCourseComponentsFail,
    addCourseComponentSuccess,
    addCourseComponentFail,
    updateCourseComponentSuccess,
    updateCourseComponentFail,
    deleteCourseComponentSuccess,
    deleteCourseComponentFail,
   
} from "./actions"

import {
    getCourseComponents,
    addNewCourseComponent,
    updateCourseComponent,
    deleteCourseComponent,
   
} from "helpers/course-components/course_components_backend_helper";
import { toast } from "react-toastify";

function* fetchCourseComponents() {
    try {

        console.log("ON SUBJECTS FETCH");
        const response = yield call(getCourseComponents)

        
        yield put(getCourseComponentsSuccess(response))
    } catch (error) {
        yield put(getCourseComponentsFail(error))
    }
}

function* onAddNewCourseComponent({ payload }) {
    try {

        
        const response = yield call(addNewCourseComponent, payload)

        console.log("RESPONSE:", response);
        yield put(addCourseComponentSuccess(response.courseComponent))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addCourseComponentFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateCourseComponent({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateCourseComponent, payload)
        yield put(updateCourseComponentSuccess(response.courseComponent))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateCourseComponentFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteCourseComponent({ payload: data }) {

    try {
        const response = yield call(deleteCourseComponent, data)
        yield put(deleteCourseComponentSuccess(response.courseComponentId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteCourseComponentFail(error))
        toast.error("Branch  Deleted Failed", { autoClose: 2000 });
    }
}


function* courseComponentSaga() {
    yield takeEvery(GET_COURSE_COMPONENTS, fetchCourseComponents)
    yield takeEvery(ADD_NEW_COURSE_COMPONENT, onAddNewCourseComponent)
    yield takeEvery(UPDATE_COURSE_COMPONENT, onUpdateCourseComponent)
    yield takeEvery(DELETE_COURSE_COMPONENT, onDeleteCourseComponent)
}

export default courseComponentSaga;